import { render } from "./FarmOSArea.vue?vue&type=template&id=865cb09e"
import script from "./FarmOSArea.vue?vue&type=script&lang=js"
export * from "./FarmOSArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__